import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { consumeSessionExpiredNotice } from '../../services/authSession';

const SESSION_EXPIRED_TOAST_ID = 'session-expired-notice';

const SessionExpiryNotice = () => {
  useEffect(() => {
    const message = consumeSessionExpiredNotice();
    if (!message) return;

    toast.info(message, {
      toastId: SESSION_EXPIRED_TOAST_ID,
    });
  }, []);

  return null;
};

export default SessionExpiryNotice;
